export function invokeFitDataOnApply(ctx, fitDataResult) {
  if (!fitDataResult) return;
  try {
    var _fitDataResult$onAppl;
    (_fitDataResult$onAppl = fitDataResult.onApply) === null || _fitDataResult$onAppl === void 0 || _fitDataResult$onAppl.call(fitDataResult, ctx);
  } finally {
    ctx.uc.hooks.fitDataOnApply.call(ctx, fitDataResult);
  }
}
//# sourceMappingURL=invokeCallbacks.js.map
